module.exports = __webpack_public_path__ + "static/custommade-0b3f5ef96535e692c7e6fec5e8af066b.png";